var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',[_vm._l((_vm.items),function(ref,keyItems){
var img = ref.img;
var link = ref.link;
var target = ref.target;
return [(img)?_c('Modal',{key:keyItems},[(link)?_c('a',{attrs:{"href":link,"target":target ? '_blank' : '_self'}},[_c('img',{staticClass:"d-block",attrs:{"src":_vm.files + img,"width":"100%"}})]):_c('img',{staticClass:"d-block",attrs:{"src":_vm.files + img,"width":"100%"}})]):_vm._e()]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }